import React, { useMemo, useEffect } from "react";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import Expandible from "../../layout/HelperDataTable/Expandible";
import { MaterialReactTable } from "material-react-table";
import { useCompleteTableConfig } from "../../constants";
import { dataNormatividad } from "../../data/2024/dataArchivo";
import {
  AcuerdosDetailContainer,
  AcuerdosDetailSection,
  AcuerdosDetailRow,
} from "../../components/acuerdos/AcuerdosDetail";

const InstrumentosNormativos = () => {
  useEffect(() => {
    document.title = `Instrumentos Normativos`;
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "NO.",
        size: 70,
      },
      {
        accessorKey: "nameDoc",
        id: "nameDoc",
        header: "NORMATIVIDAD",
        size: 450,
        minSize: 320,
      },
      {
        accessorKey: "post",
        header: "PUBLICADA",
        size: 140,
        Cell: ({ cell }) => cell.getValue() || "—",
      },
      {
        accessorKey: "lastUpdate",
        header: "ÚLTIMA REFORMA",
        size: 140,
        Cell: ({ cell }) => cell.getValue() || "—",
      },
    ],
    []
  );

  const renderNormativos = ({ row }) => {
    const hasPdf = Boolean(row.original.pdf);
    const hasPdfMobile = Boolean(row.original.pdfMobile);
    const hasWord = Boolean(row.original.word);
    const hasExcel = Boolean(row.original.excel);

    if (!hasPdf && !hasPdfMobile && !hasWord && !hasExcel) {
      return null;
    }

    return (
      <AcuerdosDetailContainer>
        <AcuerdosDetailSection title="DOCUMENTO">
          {hasPdf && (
            <AcuerdosDetailRow
              title={`${row.original.nameDoc} (PDF)`}
              url={row.original.pdf}
              type="pdf"
              isMain={true}
            />
          )}
          {hasPdfMobile && (
            <AcuerdosDetailRow
              title={`${row.original.nameDoc} (PDF Móvil)`}
              url={row.original.pdfMobile}
              type="pdf"
            />
          )}
          {hasWord && (
            <AcuerdosDetailRow
              title={`${row.original.nameDoc} (Word)`}
              url={row.original.word}
              type="word"
            />
          )}
          {hasExcel && (
            <AcuerdosDetailRow
              title={`${row.original.nameDoc} (Excel)`}
              url={row.original.excel}
              type="excel"
            />
          )}
        </AcuerdosDetailSection>
      </AcuerdosDetailContainer>
    );
  };

  const table = useCompleteTableConfig(
    dataNormatividad,
    columns,
    renderNormativos
  );

  return (
    <div className="margin-bottom-2">
      <Breadcrumbs
        path={[{ label: "Archivo" }, { label: "Instrumentos Normativos" }]}
      />
      <TitlePages title="Archivo" subTitle="Instrumentos Normativos" />
      <Expandible />
      <MaterialReactTable table={table} />
    </div>
  );
};

export default InstrumentosNormativos;
